import { useQuery } from '@tanstack/react-query';
import { getUserPhoto } from '../api/getUserPhoto';
import { useUserStore } from '../model/store/useUserStore';

export const useUserPhoto = () => {
    const {
        user: { userId },
    } = useUserStore();

    const { data, isLoading, isError } = useQuery({
        queryKey: ['userPhoto', userId],
        queryFn: () => getUserPhoto({ id: userId }),
        retry: false,
        refetchOnWindowFocus: false,
    });

    return {
        data,
        isLoading,
        isError,
    };
};
